import { useUrlQuery } from './useUrlQuery';

export function useUrlQueryParam(key: string) {
  return useUrlQuery().get(key) ?? undefined;
}
